import { PhoneCell } from 'components/FlexTable/components/cells/phone';
import { FlexTableV2 } from 'components/FlexTableV2';
import { IconsChannel } from 'components/IconsChannel/IconsChannel';
import UncontrolledDefaultModal from 'components/Modal/UncontrolledDefaultModal';
import React from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import { Button, Card, Row } from 'reactstrap';
import {
  icon_column_style,
  individual_column_style,
  individual_header_style,
  individual_icon_header_style
} from '../../../../assets/styles/table_custom_style';
import { SurveyDetailsChat } from '../../../../components/Survey/SurveyDetailsChat';
import { SurveyDetailsTelephony } from '../../../../components/Survey/SurveyDetailsTelephony';
import { TotalRegister } from '../../../../components/TotalRegister';
import { ControlAudioProvider } from './hooks/useControlAudioState';
import { toast } from 'react-toastify';

const subResponseColumns = [
  {
    id: 'question_name',
    header: 'Nome da pergunta',
    accessorKey: 'question_name'
  },
  {
    id: 'type',
    header: 'Tipo',
    accessorKey: 'type'
  },

  {
    id: 'label',
    header: 'Resposta',
    accessorKey: 'label'
  },
  {
    id: 'rate',
    header: 'Nota',
    accessorKey: 'rate'
  },
  {
    id: 'customer_response',
    header: 'Resposta textual',
    accessorKey: 'customer_response'
  },
  {
    id: 'date_of_response',
    header: 'Data da resposta',
    accessorFn: (row) => new Date(row.date_of_response).toLocaleString('pt-BR')
  }
];

const Table = ({ showReports, totalRegister }) => {
  return (
    <>
      <Row>
        <div className="col">
          <div className="card-wrapper">
            {totalRegister >= 0 && (
              <TotalRegister totalRegister={totalRegister} />
            )}
            <Card>
              <ToolkitProvider
                data={showReports || []}
                keyField="_id"
                columns={[
                  {
                    dataField: 'date',
                    text: 'Data Resposta',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    formatter: (Row) => {
                      const date = new Date(Row);
                      return `${date.toLocaleDateString(
                        'pt-br'
                      )} ${date.toLocaleTimeString('pt-br')}`;
                    }
                  },
                  {
                    dataField: 'rate',
                    text: 'Nota',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'name',
                    text: 'Nome da pesquisa',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'tag',
                    text: 'Tag',
                    sort: true,
                    style: icon_column_style,
                    headerStyle: individual_icon_header_style
                  },
                  {
                    dataField: 'agentName',
                    text: 'Atendente',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'customer',
                    text: 'Cliente',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'customerPhone',
                    text: 'Contato',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    formatter: (_, row) => {
                      return (
                        <PhoneCell
                          phone={row?.customerPhone}
                          ddi={row?.customerPhoneDDI}
                        />
                      );
                    }
                  },
                  {
                    dataField: 'queueName',
                    text: 'Fila',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style
                  },
                  {
                    dataField: 'typeSurvey',
                    text: 'Tipo de pesquisa',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    formatter: (Row) => {
                      if (Row !== 'NPS' && Row !== 'SATISFACAO') {
                        toast.warn(
                          'Nosso sistema identificou que a tabela pode estar exibindo dados inconsistentes. Por gentileza, verifique as informações apresentadas e, caso a inconsistência seja confirmada, informe o suporte para a devida análise.'
                        );
                      }

                      return Row === 'NPS' ? 'NPS' : 'CSAT';
                    }
                  },
                  {
                    dataField: 'channel',
                    text: 'Canal',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    formatter: (Row) => {
                      return <IconsChannel channel={Row} />;
                    }
                  },
                  {
                    dataField: 'origin',
                    text: 'Origem',
                    sort: true,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    formatter: (_, Row) => {
                      return <IconsChannel channel={Row.channel} />;
                    }
                  },
                  {
                    dataField: 'details',
                    text: 'Detalhes',
                    sort: false,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    // eslint-disable-next-line react/display-name
                    formatter: (_, row) => {
                      if (!row.channel) return null;

                      return (
                        <>
                          {row.channel !== 'voice' ? (
                            <SurveyDetailsChat id={row.attendanceId} />
                          ) : (
                            <ControlAudioProvider>
                              <SurveyDetailsTelephony
                                id_attendance={row.attendanceId}
                              />
                            </ControlAudioProvider>
                          )}
                        </>
                      );
                    }
                  },
                  {
                    dataField: 'subResponses',
                    text: 'Perguntas',
                    sort: false,
                    style: individual_column_style,
                    headerStyle: individual_header_style,
                    formatter: (_, row) => {
                      if (!row?.subResponses?.length) return '-';

                      const triggerButton = (
                        <Button size="sm" color="primary">
                          <i className="fas fa-question-circle"></i>
                        </Button>
                      );

                      const sorted = [...row.subResponses].sort(
                        (a, b) =>
                          new Date(a.date_of_response).getTime() -
                          new Date(b.date_of_response).getTime()
                      );

                      return (
                        <UncontrolledDefaultModal
                          trigger={triggerButton}
                          title={`Perguntas Respondidas - ${row.name}`}
                          subtitle={`Atendimento #${row.attendanceId}`}
                          centered
                          size="lg"
                          body={
                            <div className="p-2 px-4">
                              <FlexTableV2
                                table={{
                                  data: sorted,
                                  columns: subResponseColumns,
                                  enableLocalStorageMemo: false,
                                  enableLocalStorageClearing: false,
                                  enableColumnResizing: false
                                }}
                                state={{
                                  setColumnSizing: () => {}
                                }}
                              />
                            </div>
                          }
                          footer={({ closeModal }) => (
                            <div className="modal-footer">
                              <Button color="danger" onClick={closeModal}>
                                Fechar
                              </Button>
                            </div>
                          )}
                        />
                      );
                    }
                  }
                ]}
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <BootstrapTable
                      {...props.baseProps}
                      bootstrap4={true}
                      bordered={false}
                      classes="align-items-center"
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Card>
          </div>
        </div>
      </Row>
    </>
  );
};
export default Table;
